/**
 * SECTION — MAIN ARTICLE (Carnet · La Note)
 *
 * Fills the reading-progress thread along the rail edge while the page
 * scrolls, and fades it out once the sticky rail is no longer pinned.
 * Progressive enhancement: without JS the thread is hidden in CSS.
 */
(function () {
  'use strict';

  function init() {
    var stage = document.querySelector('[data-article-stage]');
    if (!stage) return;
    var read = stage.querySelector('[data-article-read]');
    var bar = stage.querySelector('[data-article-progress]');
    if (!read || !bar) return;

    var footerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--footer-height'), 10) || 56;
    var ticking = false;

    function update() {
      ticking = false;
      var rect = read.getBoundingClientRect();
      var start = rect.top + window.scrollY;
      var end = start + rect.height - window.innerHeight * 0.62;
      var p = Math.min(Math.max((window.scrollY - start) / Math.max(end - start, 1), 0), 1);
      bar.style.setProperty('--p', (p * 100).toFixed(1) + '%');

      // the thread only lives while the sticky rail is pinned
      var s = stage.getBoundingClientRect();
      var pinned = s.top <= 1 && s.bottom >= window.innerHeight - footerH - 1;
      bar.classList.toggle('is-off', !pinned);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
